export async function getGeolocationStatus() {
	if (!("geolocation" in navigator && "permissions" in navigator)) {
		return {
			status: false,
			id: 5,
			text: "⚠️ Ваш браузер не підтримує перевірку дозволів геолокації."
		};
	}

	try {
		const result = await navigator.permissions.query({ name: "geolocation" });

		switch (result.state) {
			case "granted":
				return { status: true, id: 4, text: "✅ Геолокація увімкнена, доступ дозволено." };

			case "prompt":
				return new Promise((resolve) => {
					navigator.geolocation.getCurrentPosition(
						(position) => {
							resolve({
								status: true,
								id: 6,
								text: `✅ Користувач дозволив доступ до геоданих. Широта: ${ position.coords.latitude }, Довгота: ${ position.coords.longitude }`
							});
						},
						(error) => {
							if (error.code === error.PERMISSION_DENIED) {
								resolve({
									status: false,
									id: 7,
									text: "❌ Користувач відмовився від доступу до геоданих."
								});
							} else {
								resolve({
									status: false,
									id: 8,
									text: `‼️ Помилка при отриманні геоданих: ${ error.message }`
								});
							}
						}
					);
				});

			case "denied":
				return { status: false, id: 2, text: "❌ Геолокацію вимкнено у налаштуваннях." };
		}
	} catch (error) {
		return {
			status: false,
			id: 1,
			text: `‼️ Помилка під час перевірки геолокації: ${ error.message }`
		};
	}
}
